import { ErrorMessage } from 'components/ErrorPages/ErrorMessage'

const NotFound = () => <ErrorMessage errorType="notFound" />

export default NotFound
